// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3X3e-","itemTitle":"ClientEmergencyInfo_itemTitle__2lKNQ","itemText":"ClientEmergencyInfo_itemText__1RfHd"};